export default "__VITE_ASSET__BDaLXo3u__"